import React, { useEffect, useRef, useState } from "react";
import styles from "../../../styles/achievement.module.css";

function AnimatedCount({ end, suffix = "+" }) {
  const [count, setCount] = useState(0);
  const [hasStarted, setHasStarted] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const node = containerRef.current;
    if (!node) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setHasStarted(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );

    observer.observe(node);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!hasStarted) {
      return undefined;
    }

    let frameId;
    const duration = 1000;
    const startTime = performance.now();

    const animate = (timestamp) => {
      const progress = Math.min((timestamp - startTime) / duration, 1);
      setCount(Math.round(progress * end));

      if (progress < 1) {
        frameId = window.requestAnimationFrame(animate);
      }
    };

    frameId = window.requestAnimationFrame(animate);

    return () => window.cancelAnimationFrame(frameId);
  }, [end, hasStarted]);

  return <span ref={containerRef}>{count}{suffix}</span>;
}

const Achievement = () => {
  return (
    <>
      <div className={styles.achievements_offers}>
        <div className={styles.offers}>
          <h2>Our Responsibility</h2>
          <div className={styles.offerwrapper}>
            <div className={styles.offer}>
              <svg
                width="800px"
                height="800px"
                viewBox="0 0 64 64"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g data-name="17_Graduation" id="_17_Graduation">
                  <rect
                    height="10"
                    style={{ fill: "#febc00" }}
                    width="54"
                    x="5"
                    y="36"
                  />

                  <path
                    d="M7,36H5V46H59V44H15A8,8,0,0,1,7,36Z"
                    style={{ fill: "#edaa03" }}
                  />

                  <path
                    d="M34.044,45.477a8,8,0,0,1-6.529-4.087L17,51.907a1,1,0,0,0,.516,1.689l2.854.555.579,2.883a1,1,0,0,0,1.688.51L34.327,45.853,34,45.523Z"
                    style={{ fill: "#cc2600" }}
                  />

                  <path
                    d="M46.156,51.407l-10.3-10.3a8,8,0,0,1-6.728,3.889l.03.029-.329.33L40.519,57.044a1,1,0,0,0,1.687-.51l.579-2.883L45.64,53.1a1,1,0,0,0,.516-1.689Z"
                    style={{ fill: "#cc2600" }}
                  />

                  <path
                    d="M32.126,47.994c-.042,0-.083.006-.126.006-.154,0-.3-.014-.456-.023l-.046.046.329.33.329-.33Z"
                    style={{ fill: "#cc2600" }}
                  />

                  <path
                    d="M15,12H49a0,0,0,0,1,0,0V30a2,2,0,0,1-2,2H17a2,2,0,0,1-2-2V12A0,0,0,0,1,15,12Z"
                    style={{ fill: "#0455bf" }}
                  />

                  <path
                    d="M17,12H15V30a2,2,0,0,0,2,2H47a2,2,0,0,0,2-2H35A18,18,0,0,1,17,12Z"
                    style={{ fill: "#004787" }}
                  />

                  <rect
                    height="12"
                    style={{ fill: "#0455bf" }}
                    width="2"
                    x="53"
                    y="11"
                  />

                  <rect
                    height="12"
                    style={{ fill: "#004787" }}
                    width="1"
                    x="54"
                    y="11"
                  />

                  <path
                    d="M56.25,34h-4.5c-.414,0-.75-.447-.75-1V22c0-.553.336-1,.75-1h4.5c.414,0,.75.447.75,1V33C57,33.553,56.664,34,56.25,34Z"
                    style={{ fill: "#f74e0c" }}
                  />

                  <path
                    d="M53.75,32c-.414,0-.75-.447-.75-1V21H51.75c-.414,0-.75.447-.75,1V33c0,.553.336,1,.75,1h4.5c.414,0,.75-.447.75-1V32Z"
                    style={{ fill: "#cc2600" }}
                  />

                  <path
                    d="M5,46c-1.71,0-3-2.149-3-5s1.29-5,3-5,3,2.149,3,5S6.71,46,5,46Z"
                    style={{ fill: "#f74e0c" }}
                  />

                  <path
                    d="M4,40a6.5,6.5,0,0,1,1.157-3.975C5.1,36.021,5.054,36,5,36c-1.71,0-3,2.149-3,5s1.29,5,3,5a2.37,2.37,0,0,0,1.843-1.025C5.214,44.845,4,42.761,4,40Z"
                    style={{ fill: "#cc2600" }}
                  />

                  <path
                    d="M59,46c-1.71,0-3-2.149-3-5s1.29-5,3-5,3,2.149,3,5S60.71,46,59,46Z"
                    style={{ fill: "#f74e0c" }}
                  />

                  <path
                    d="M32,49a8,8,0,1,1,8-8A8.009,8.009,0,0,1,32,49Z"
                    style={{ fill: "#f74e0c" }}
                  />

                  <path
                    d="M32,45a4,4,0,1,1,4-4A4,4,0,0,1,32,45Z"
                    style={{ fill: "#cc2600" }}
                  />

                  <path
                    d="M56,14H8a1,1,0,0,1-1-1V9A1,1,0,0,1,8,8H56a1,1,0,0,1,1,1v4A1,1,0,0,1,56,14Z"
                    style={{ fill: "#0455bf" }}
                  />

                  <path
                    d="M57,12H9V8H8A1,1,0,0,0,7,9v4a1,1,0,0,0,1,1H56a1,1,0,0,0,1-1Z"
                    style={{ fill: "#004787" }}
                  />
                </g>
              </svg>
              <h4>Scholarship</h4>
              <p>
                We offer scholarships to deserving students to help them achieve
                their educational goals.
              </p>
            </div>

            <div className={styles.offer}>
              <svg
                height="800px"
                width="800px"
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 503.7 503.7"
                xmlSpace="preserve"
              >
                <g transform="translate(1 1)">
                  <path
                    style={{fill:"#FFD0A1"}}
                    d="M344.7,327.7V169.8h0.9c13.7,15.4,33.3,38.4,67.4,38.4s34.1-8.5,34.1-8.5v128
		c0,4.3,0.9,10.2,3.4,17.1c5.1,17.9,13.7,41,13.7,59.7v42.7v34.1c0,9.4-7.7,17.1-17.1,17.1s-17.1-7.7-17.1-17.1
		c0,9.4-7.7,17.1-17.1,17.1s-17.1-7.7-17.1-17.1c0,9.4-7.7,17.1-17.1,17.1s-17.1-7.7-17.1-17.1c0,9.4-7.7,17.1-17.1,17.1
		s-17.1-7.7-17.1-17.1v-34.1c-11.9,8.5-25.6,0-25.6,0s-8.5,0-8.5-34.1c0-35,23.9-53.8,39.3-68.3
		C339.5,338.8,344.7,332.8,344.7,327.7z M447.1,3.4v34.1h-42.7c-18.8,0-41.8,9.4-59.7,13.7V3.4H447.1z"
                  />
                  <path
                    style={{fill:"#AE938D"}}
                    d="M327.6,157H169.7h-0.9c15.4-13.7,39.3-33.3,39.3-68.3c0-34.1-8.5-34.1-8.5-34.1h128
		c4.3,0,10.2-0.9,17.1-3.4c17.9-5.1,41-13.7,59.7-13.7h42.7h34.1c9.4,0,17.1,7.7,17.1,17.1s-7.7,17.1-17.1,17.1
		c9.4,0,17.1,7.7,17.1,17.1s-7.7,17.1-17.1,17.1c9.4,0,17.1,7.7,17.1,17.1s-7.7,17.1-17.1,17.1c9.4,0,17.1,7.7,17.1,17.1
		s-7.7,17.1-17.1,17.1h-34.1c8.5,11.9,0,25.6,0,25.6s0,8.5-34.1,8.5c-35,0-53.8-23.9-67.4-38.4C338.7,162.2,332.7,157,327.6,157z
		 M51.1,157H3.3V54.6h34.1v42.7C37.5,116.1,46.9,139.1,51.1,157z"
                  />
                  <path
                    style={{fill:"#F2EDDA"}}
                    d="M54.5,327.7c-8.5-11.9,0-25.6,0-25.6s0-8.5,34.1-8.5c35,0,53.8,23.9,68.3,38.4
		c6.8,6.8,11.9,12.8,17.1,12.8h157.9h0.9c-15.4,13.7-39.3,33.3-39.3,68.3c0,34.1,8.5,34.1,8.5,34.1H174c-4.3,0-10.2,0.9-17.1,3.4
		c-17.9,5.1-41,13.7-59.7,13.7H54.5H20.4c-9.4,0-17.1-7.7-17.1-17.1s7.7-17.1,17.1-17.1c-9.4,0-17.1-7.7-17.1-17.1
		s7.7-17.1,17.1-17.1c-9.4,0-17.1-7.7-17.1-17.1s7.7-17.1,17.1-17.1c-9.4,0-17.1-7.7-17.1-17.1s7.7-17.1,17.1-17.1h34.1V327.7z
		 M498.3,344.8v102.4h-34.1v-42.7c0-18.8-9.4-41.8-13.7-59.7L498.3,344.8L498.3,344.8z"
                  />
                  <path
                    style={{fill:"#FFD0A1"}}
                    d="M156.9,450.6v47.8H54.5v-34.1h42.7C116,464.2,139,454.8,156.9,450.6z M174,54.6
		c11.9-8.5,25.6,0,25.6,0s8.5,0,8.5,34.1c0,35-23.9,53.8-39.3,68.3c-6.8,6.8-11.9,11.9-11.9,17.1V332l0,0
		c-13.7-15.4-33.3-38.4-68.3-38.4c-34.1,0-34.1,8.5-34.1,8.5v-128c0-4.3-0.9-10.2-3.4-17.1c-5.1-17.9-13.7-41-13.7-59.7V54.6V20.5
		c0-9.4,7.7-17.1,17.1-17.1s17.1,7.7,17.1,17.1c0-9.4,7.7-17.1,17.1-17.1s17.1,7.7,17.1,17.1c0-9.4,7.7-17.1,17.1-17.1
		S140,11.1,140,20.5c0-9.4,7.7-17.1,17.1-17.1s17.1,7.7,17.1,17.1v34.1H174z"
                  />
                </g>
                <path
                  style={{fill:"#51565F"}}
                  d="M448.1,503.6c-6.8,0-12.8-3.4-17.1-8.5c-4.3,5.1-10.2,8.5-17.1,8.5s-12.8-3.4-17.1-8.5
	c-4.3,5.1-10.2,8.5-17.1,8.5s-12.8-3.4-17.1-8.5c-4.3,5.1-10.2,8.5-17.1,8.5c-11.9,0-21.3-9.4-21.3-21.3V414c0-2.6,1.7-4.3,4.3-4.3
	c2.6,0,4.3,1.7,4.3,4.3v68.3c0,6.8,6,12.8,12.8,12.8s12.8-6,12.8-12.8c0-2.6,1.7-4.3,4.3-4.3s4.3,1.7,4.3,4.3
	c0,6.8,6,12.8,12.8,12.8s12.8-6,12.8-12.8c0-2.6,1.7-4.3,4.3-4.3s4.3,1.7,4.3,4.3c0,6.8,6,12.8,12.8,12.8s12.8-6,12.8-12.8
	c0-2.6,1.7-4.3,4.3-4.3s4.3,1.7,4.3,4.3c0,6.8,6,12.8,12.8,12.8s12.8-6,12.8-12.8v-76.8c0-13.7-5.1-29.9-9.4-44.4
	c-4.3-12.8-7.7-23.9-7.7-32.4v-85.3c0-2.6,1.7-4.3,4.3-4.3c2.6,0,4.3,1.7,4.3,4.3v85.3c0,3.4,0.9,7.7,1.7,12.8h45.2
	c2.6,0,4.3,1.7,4.3,4.3s-1.7,4.3-4.3,4.3h-42.7c0.9,2.6,1.7,6,2.6,8.5c5.1,15.4,10.2,32.4,10.2,46.9v38.4h29.9
	c2.6,0,4.3,1.7,4.3,4.3c0,2.6-1.7,4.3-4.3,4.3h-29.9v29.9C469.4,494.2,460,503.6,448.1,503.6z M157.9,503.6c-2.6,0-4.3-1.7-4.3-4.3
	v-42.7c-2.6,0.9-6,1.7-8.5,2.6c-15.4,5.1-32.4,10.2-46.9,10.2H59.8v29.9c0,2.6-1.7,4.3-4.3,4.3s-4.3-1.7-4.3-4.3v-29.9H21.4
	c-11.9,0-21.3-9.4-21.3-21.3c0-6.8,3.4-12.8,8.5-17.1c-5.1-4.3-8.5-10.2-8.5-17.1c0-6.8,3.4-12.8,8.5-17.1
	c-5.1-4.3-8.5-10.2-8.5-17.1s3.4-12.8,8.5-17.1c-5.1-4.3-8.5-10.2-8.5-17.1c0-11.9,9.4-21.3,21.3-21.3h68.3c2.6,0,4.3,1.7,4.3,4.3
	c0,2.6-1.7,4.3-4.3,4.3H21.4c-6.8,0-12.8,6-12.8,12.8s6,12.8,12.8,12.8c2.6,0,4.3,1.7,4.3,4.3c0,2.6-1.7,4.3-4.3,4.3
	c-6.8,0-12.8,6-12.8,12.8s6,12.8,12.8,12.8c2.6,0,4.3,1.7,4.3,4.3c0,2.6-1.7,4.3-4.3,4.3c-6.8,0-12.8,6-12.8,12.8s6,12.8,12.8,12.8
	c2.6,0,4.3,1.7,4.3,4.3s-1.7,4.3-4.3,4.3c-6.8,0-12.8,6-12.8,12.8s6,12.8,12.8,12.8h76.8c13.7,0,29.9-5.1,44.4-9.4
	c12.8-4.3,23.9-7.7,32.4-7.7h85.3c2.6,0,4.3,1.7,4.3,4.3c0,2.6-1.7,4.3-4.3,4.3H175c-3.4,0-7.7,0.9-12.8,1.7v45.2
	C162.2,501.9,160.5,503.6,157.9,503.6z M303,452.4c-5.1,0-12.8-5.1-12.8-38.4c0-34.1,21.3-53.8,36.7-68.3
	c7.7-6.8,14.5-12.8,14.5-17.1V217.8c0-2.6,1.7-4.3,4.3-4.3s4.3,1.7,4.3,4.3v110.9c0,8.5-7.7,15.4-17.1,23.9
	c-14.5,12.8-34.1,31.6-34.1,61.4c0,24.7,4.3,29,5.1,29.9c1.7,0,3.4,2.6,3.4,4.3C307.3,450.7,305.6,452.4,303,452.4z M285.9,350H175
	c-8.5,0-15.4-7.7-23.9-17.1c-12.8-14.5-31.6-34.1-61.4-34.1c-24.7,0-29,4.3-29.9,5.1c0,1.7-1.7,3.4-4.3,3.4s-4.3-1.7-4.3-4.3
	c0-5.1,5.1-12.8,38.4-12.8c34.1,0,53.8,21.3,68.3,36.7c6.8,7.7,12.8,14.5,17.1,14.5h110.9c2.6,0,4.3,1.7,4.3,4.3
	S288.5,350,285.9,350z M157.9,290.3c-2.6,0-4.3-1.7-4.3-4.3V175.1c0-8.5,7.7-15.4,17.1-23.9c14.5-12.8,34.1-31.6,34.1-61.4
	c0-24.7-4.3-29-5.1-29.9c-1.7,0-3.4-1.7-3.4-4.3s1.7-4.3,4.3-4.3c5.1,0,12.8,5.1,12.8,38.4c0,34.1-21.3,53.8-36.7,68.3
	c-7.7,6.8-14.5,12.8-14.5,17.1V286C162.2,288.6,160.5,290.3,157.9,290.3z M55.5,264.7c-2.6,0-4.3-1.7-4.3-4.3v-85.3
	c0-3.4-0.9-7.7-1.7-12.8H4.3c-2.6,0-4.3-1.7-4.3-4.3s1.7-4.3,4.3-4.3H47c-0.9-2.6-1.7-6-2.6-8.5c-4.3-15.4-10.2-32.4-10.2-46.9V59.9
	H4.3c-2.6,0-4.3-1.7-4.3-4.3s1.7-4.3,4.3-4.3h29.9V21.5c0-11.9,9.4-21.3,21.3-21.3c6.8,0,12.8,3.4,17.1,8.5
	c4.3-5.1,10.2-8.5,17.1-8.5c6.8,0,12.8,3.4,17.1,8.5c4.3-5.1,10.2-8.5,17.1-8.5s12.8,3.4,17.1,8.5c4.3-5.1,10.2-8.5,17.1-8.5
	c11.9,0,21.3,9.4,21.3,21.3v68.3c0,2.6-1.7,4.3-4.3,4.3s-4.3-1.7-4.3-4.3V21.5c0-6.8-6-12.8-12.8-12.8s-12.8,6-12.8,12.8
	c0,2.6-1.7,4.3-4.3,4.3s-4.3-1.7-4.3-4.3c0-6.8-6-12.8-12.8-12.8s-12.8,6-12.8,12.8c0,2.6-1.7,4.3-4.3,4.3s-4.3-1.7-4.3-4.3
	c0-6.8-6-12.8-12.8-12.8s-12.8,6-12.8,12.8c0,2.6-1.7,4.3-4.3,4.3c-2.6,0-4.3-1.7-4.3-4.3c0-6.8-6-12.8-12.8-12.8s-12.8,6-12.8,12.8
	v76.8c0,13.7,5.1,29.9,9.4,44.4c4.3,12.8,7.7,23.9,7.7,32.4v85.3C59.8,263,58.1,264.7,55.5,264.7z M413.9,213.5
	c-34.1,0-53.8-21.3-68.3-36.7c-6.8-7.7-12.8-14.5-17.1-14.5H217.7c-2.6,0-4.3-1.7-4.3-4.3s1.7-4.3,4.3-4.3h110.9
	c8.5,0,15.4,7.7,23.9,17.1c12.8,14.5,31.6,34.1,61.4,34.1c24.7,0,29-4.3,29.9-5.1c0-1.7,2.6-3.4,4.3-3.4c2.6,0,4.3,1.7,4.3,4.3
	C452.3,205.8,447.2,213.5,413.9,213.5z M482.2,179.4h-68.3c-2.6,0-4.3-1.7-4.3-4.3s1.7-4.3,4.3-4.3h68.3c6.8,0,12.8-6,12.8-12.8
	s-6-12.8-12.8-12.8c-2.6,0-4.3-1.7-4.3-4.3s1.7-4.3,4.3-4.3c6.8,0,12.8-6,12.8-12.8s-6-12.8-12.8-12.8c-2.6,0-4.3-1.7-4.3-4.3
	s1.7-4.3,4.3-4.3c6.8,0,12.8-6,12.8-12.8s-6-12.8-12.8-12.8c-2.6,0-4.3-1.7-4.3-4.3c0-2.6,1.7-4.3,4.3-4.3c6.8,0,12.8-6,12.8-12.8
	s-6-12.8-12.8-12.8h-76.8c-13.7,0-29.9,5.1-44.4,9.4c-12.8,4.3-23.9,7.7-32.4,7.7h-85.3c-2.6,0-4.3-1.7-4.3-4.3s1.7-4.3,4.3-4.3
	h85.3c3.4,0,7.7-0.9,12.8-1.7v-45c0-2.6,1.7-4.3,4.3-4.3s4.3,1.7,4.3,4.3v42.7c2.6-0.9,6-1.7,8.5-2.6c15.4-4.3,32.4-10.2,46.9-10.2
	h38.4V4.4c0-2.6,1.7-4.3,4.3-4.3c2.6,0,4.3,1.7,4.3,4.3v29.9h29.9c11.9,0,21.3,9.4,21.3,21.3c0,6.8-3.4,12.8-8.5,17.1
	c5.1,4.3,8.5,10.2,8.5,17.1c0,6.8-3.4,12.8-8.5,17.1c5.1,4.3,8.5,10.2,8.5,17.1s-3.4,12.8-8.5,17.1c5.1,4.3,8.5,10.2,8.5,17.1
	C503.5,170,494.1,179.4,482.2,179.4z"
                />
              </svg>
              <h4>Help Current Students</h4>
              <p>
                We provide support and resources to current students to help them succeed academically and personally.
              </p>
            </div>

            <div className={styles.offer}>
              <svg
                width="800px"
                height="800px"
                viewBox="0 0 1024 1024"
                className="icon"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M886.8 377.4c-5.3-8.9-18-16.1-28.3-16.1H167.7c-10.3 0-23 7.2-28.3 16.1l-54 90.7c-5.3 8.9-1.2 16.1 9.1 16.1h837.1c10.3 0 14.4-7.2 9.1-16.1l-53.9-90.7z"
                  fill="#00B3E3"
                />
                <path
                  d="M900.9 401.2H576.1v28.6H918l-17.1-28.6z m-792.7 28.6h338.1v-28.6h-321l-17.1 28.6z"
                  fill=""
                />
                <path
                  d="M608.5 479.6l-97.3-156.2-97.4 156.2H87.1v378h848.1v-378z"
                  fill="#D1D3D3"
                />
                <path
                  d="M638.9 499.9c-7.1 0-15.9-4.9-19.7-10.9l-5.9-9.4h-4.9L517.7 334c-4.3-2-8.9-2-13.3 0l-90.7 145.6H409l-5.9 9.4c-3.8 6-12.6 10.9-19.7 10.9H87.1v50.2h312.2c7.1 0 15.8-5 19.3-11.1l76.2-116.7c8.9-15.2 23.6-15.2 32.5 0L603.5 539c3.6 6.1 12.2 11.1 19.3 11.1H935v-50.2H638.9z"
                  fill=""
                />
                <path
                  d="M852.8 559.2h82.4v39.6h-82.4zM605.8 641.2h82.4v39.6h-82.4zM754.9 781.9h82.4v39.6h-82.4zM327.4 792.5h82.4v39.6h-82.4zM87.1 597.2h82.4v39.6H87.1zM286.2 515.2h82.4v39.6h-82.4z"
                  fill="#A4A9AD"
                />
                <path d="M440.4 663h141.5v194.6H440.4z" fill="#333E48" />
                <path
                  d="M467.4 708H496v53.9h-28.6zM526.3 708h28.6v53.9h-28.6zM292.5 630.2h83.2v114.4h-83.2z"
                  fill="#FFFFFF"
                />
                <path d="M292.5 630.2h83.2v25.2h-83.2z" fill="" />
                <path d="M292.5 673.1h83.2v28.6h-83.2z" fill="#A93439" />
                <path
                  d="M306.8 730.3h54.6v-85.8h-54.6v85.8z m68.9 28.6h-83.2c-7.9 0-14.3-6.4-14.3-14.3V630.2c0-7.9 6.4-14.3 14.3-14.3h83.2c7.9 0 14.3 6.4 14.3 14.3v114.4c0 7.9-6.4 14.3-14.3 14.3z"
                  fill="#FF5959"
                />
                <path d="M131.1 630.2h83.2v114.4h-83.2z" fill="#FFFFFF" />
                <path d="M131.1 630.2h83.2v25.2h-83.2z" fill="" />
                <path d="M131.1 673.1h83.2v28.6h-83.2z" fill="#A93439" />
                <path
                  d="M145.4 730.3H200v-85.8h-54.6v85.8z m68.9 28.6h-83.2c-7.9 0-14.3-6.4-14.3-14.3V630.2c0-7.9 6.4-14.3 14.3-14.3h83.2c7.9 0 14.3 6.4 14.3 14.3v114.4c0 7.9-6.4 14.3-14.3 14.3z"
                  fill="#FF5959"
                />
                <path d="M646.7 630.2h83.2v114.4h-83.2z" fill="#FFFFFF" />
                <path d="M646.7 630.2h83.2v25.2h-83.2z" fill="" />
                <path d="M646.7 673.1h83.2v28.6h-83.2z" fill="#A93439" />
                <path
                  d="M661 730.3h54.6v-85.8H661v85.8z m68.8 28.6h-83.2c-7.9 0-14.3-6.4-14.3-14.3V630.2c0-7.9 6.4-14.3 14.3-14.3h83.2c7.9 0 14.3 6.4 14.3 14.3v114.4c0 7.9-6.4 14.3-14.3 14.3z"
                  fill="#FF5959"
                />
                <path d="M808 630.2h83.2v114.4H808z" fill="#FFFFFF" />
                <path d="M808 630.2h83.2v25.2H808z" fill="" />
                <path d="M808 673.1h83.2v28.6H808z" fill="#A93439" />
                <path
                  d="M822.3 730.3h54.6v-85.8h-54.6v85.8z m68.9 28.6H808c-7.9 0-14.3-6.4-14.3-14.3V630.2c0-7.9 6.4-14.3 14.3-14.3h83.2c7.9 0 14.3 6.4 14.3 14.3v114.4c0 7.9-6.4 14.3-14.3 14.3z"
                  fill="#FF5959"
                />
                <path d="M511.2 152.5h165.1v94.6H511.2z" fill="#FFB819" />
                <path d="M511.2 152.5h43.2v94.6h-43.2z" fill="" />
                <path
                  d="M511.2 337.7c-7.9 0-14.3-6.4-14.3-14.3v-184c0-7.9 6.4-14.3 14.3-14.3s14.3 6.4 14.3 14.3v184.1c0 7.8-6.4 14.2-14.3 14.2z"
                  fill="#333E48"
                />
                <path
                  d="M528.2 308.8c-9.4-15-24.7-15-34.1 0l-91 145.2c-3.8 6-12.6 10.9-19.7 10.9H79.3c-7.1 0-12.9 5.8-12.9 12.9v24.5c0 7.1 5.8 12.9 12.9 12.9h320.1c7.1 0 15.8-5 19.3-11.1l76.2-116.7c8.9-15.2 23.6-15.2 32.5 0l76.2 116.7c3.6 6.1 12.2 11.1 19.3 11.1h320c7.1 0 12.9-5.8 12.9-12.9v-24.5c0-7.1-5.8-12.9-12.9-12.9h-304c-7.1 0-15.9-4.9-19.7-10.9l-91-145.2z"
                  fill="#0071CE"
                />
                <path
                  d="M511.2 559.2m-64.9 0a64.9 64.9 0 1 0 129.8 0 64.9 64.9 0 1 0-129.8 0Z"
                  fill="#FFFFFF"
                />
                <path
                  d="M536 544.9h-10.6v-10.6c0-7.9-6.4-14.3-14.3-14.3s-14.3 6.4-14.3 14.3v24.9c0 7.9 6.4 14.3 14.3 14.3H536c7.9 0 14.3-6.4 14.3-14.3s-6.4-14.3-14.3-14.3z"
                  fill="#333E48"
                />
                <path
                  d="M959.7 892.9c0 4.2-3.5 7.7-7.7 7.7H74.2c-4.2 0-7.7-3.5-7.7-7.7v-27.6c0-4.2 3.5-7.7 7.7-7.7H952c4.2 0 7.7 3.5 7.7 7.7v27.6z"
                  fill="#00AD68"
                />
                <path d="M397.8 857.6h230.6v43H397.8z" fill="#A4A9AD" />
                <path
                  d="M914.8 857.6c0-36-29.2-65.2-65.2-65.2s-65.2 29.2-65.2 65.2h130.4zM279.4 857.6c0-36-29.2-65.2-65.2-65.2S149 821.6 149 857.6h130.4z"
                  fill="#218649"
                />
              </svg>
              <h4>Help Our School</h4>
              <p>
             Help our school by providing support and resources both academically and infrastructurally.
              </p>
            </div>

            <div className={styles.offer}>
<svg height="800px" width="800px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"  
	 viewBox="0 0 511.999 511.999" xmlSpace="preserve">
<path style={{fill:"#A5EB78"}} d="M172.903,79.434c-2.58-0.233-5.213,0.689-7.068,2.546c-1.861,1.861-2.795,4.454-2.546,7.073
	c7.077,74.219,66.202,133.215,140.584,140.27c0.28,0.025,0.56,0.043,0.836,0.043c2.33,0,4.579-0.922,6.237-2.585
	c1.861-1.861,2.795-4.454,2.546-7.073C306.414,145.482,247.289,86.49,172.903,79.434z"/>
<path style={{fill:"#8CD76E"}} d="M303.873,229.323c0.28,0.025,0.56,0.043,0.836,0.043c2.33,0,4.579-0.922,6.237-2.585L166.024,81.86
	c-0.055,0.053-0.136,0.066-0.19,0.12c-1.861,1.861-2.795,4.454-2.546,7.073C170.365,163.272,229.491,222.268,303.873,229.323z"/>
<path style={{fill:"#A5EB78"}} d="M471.491,35.321c2.58-0.233,5.213,0.689,7.068,2.546c1.861,1.861,2.795,4.454,2.546,7.073
	c-7.077,74.219-66.202,133.215-140.584,140.27c-0.28,0.025-0.56,0.043-0.836,0.043c-2.33,0-4.579-0.922-6.237-2.585
	c-1.861-1.861-2.795-4.454-2.546-7.073C337.979,101.369,397.105,42.378,471.491,35.321z"/>
<path style={{fill:"#8CD76E"}} d="M340.52,185.211c-0.28,0.025-0.56,0.043-0.836,0.043c-2.33,0-4.579-0.922-6.237-2.585L478.369,37.747
	c0.055,0.053,0.136,0.066,0.19,0.12c1.861,1.861,2.795,4.454,2.546,7.073C474.027,119.158,414.903,178.154,340.52,185.211z"/>
<path style={{fill:"#F0C087"}} d="M481.832,322.245c-11.616-2.97-23.609-0.431-32.962,7.867l-69.605,56.654
	c-2.45,1.995-5.391,3.295-8.516,3.764l-103.878,11.188l-1.997,0.012c-7.355,0-12.159-7.717-8.911-14.317
	c1.14-2.317,3.137-4.099,5.569-4.968l57.569-22.958c14.611-5.514,23.479-17.781,19.482-29.774
	c-4.835-14.506-16.908-15.438-31.612-11.763l-60.961,17.573l-92.561,6.172c-29.849,1.99-57.959,14.747-79.112,35.899l-43.78,43.78
	c-9.963,9.964-11.583,26.267-2.394,36.948c3.889,4.522,29.813,29.057,48.349,46.811c9.099,8.714,23.27,9.181,32.948,1.116
	l21.109-17.591c9.513-7.927,21.504-12.27,33.888-12.271l111.466-0.011c12.99-0.001,25.869-2.393,37.992-7.056l85.267-32.795
	c7.263-2.793,13.689-7.397,18.671-13.375l69.516-83.419C492.447,333.642,489.513,324.209,481.832,322.245z"/>
<g>
	<path style={{fill:"#73BE73"}} d="M322.042,299.94c-4.872,0-8.822-3.946-8.822-8.822V61.752c0-19.458,15.83-35.287,35.287-35.287
		c4.872,0,8.822,3.95,8.822,8.822s-3.95,8.822-8.822,8.822c-9.73,0-17.644,7.913-17.644,17.644v229.367
		C330.864,295.995,326.914,299.94,322.042,299.94z"/>
	<path style={{fill:"#73BE73"}} d="M322.042,247.949c-2.257,0-4.515-0.861-6.237-2.585l-96.73-96.73c-3.446-3.446-3.446-9.029,0-12.475
		c3.446-3.446,9.029-3.446,12.475,0l96.73,96.73c3.446,3.446,3.446,9.029,0,12.475C326.557,247.087,324.299,247.949,322.042,247.949
		z"/>
</g>
<path style={{fill:"#A5EB78"}} d="M303.905,105.854c-0.301,0-0.606-0.014-0.912-0.042c-50.416-4.792-90.489-44.867-95.282-95.282
	c-0.272-2.857,0.748-5.686,2.777-7.716c2.03-2.026,4.831-3.026,7.716-2.777c50.416,4.792,90.489,44.867,95.282,95.282
	c0.272,2.857-0.748,5.686-2.777,7.716C308.896,104.848,306.448,105.854,303.905,105.854z"/>
<path style={{fill:"#73BE73"}} d="M322.042,202.9c-2.257,0-4.515-0.861-6.237-2.585c-3.446-3.446-3.446-9.029,0-12.475l88.218-88.218
	c3.446-3.446,9.029-3.446,12.475,0c3.446,3.446,3.446,9.029,0,12.475l-88.218,88.218C326.557,202.039,324.299,202.9,322.042,202.9z"
	/>
<path style={{fill:"#8CD76E"}} d="M302.995,105.811c0.305,0.029,0.611,0.042,0.912,0.042c2.542,0,4.99-1.006,6.804-2.82L210.489,2.813
	c-2.03,2.03-3.05,4.859-2.777,7.716C212.505,60.945,252.578,101.019,302.995,105.811z"/>
<path style={{fill:"#73BE73"}} d="M322.042,123.504c-2.257,0-4.515-0.861-6.237-2.585l-61.443-61.443
	c-3.446-3.446-3.446-9.029,0-12.475c3.446-3.446,9.029-3.446,12.475,0l61.443,61.443c3.446,3.446,3.446,9.029,0,12.475
	C326.557,122.643,324.299,123.504,322.042,123.504z"/>
</svg>
              <h4>Build Our Community</h4>
              <p>
                We are a community of students, alumni, and supporters who are passionate about making a difference. Join us in building a stronger, more connected community.
              </p>
            </div>
          </div>
        </div>

        <div className={styles.achievementwrapper}>
          <div className={styles.achievement}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-people"
              viewBox="0 0 16 16"
            >
              <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1zm-7.978-1L7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002-.014.002zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0M6.936 9.28a6 6 0 0 0-1.23-.247A7 7 0 0 0 5 9c-4 0-5 3-5 4q0 1 1 1h4.216A2.24 2.24 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816M4.92 10A5.5 5.5 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4" />
            </svg>

            <div className={styles.details}>
              <p>
                <AnimatedCount end={2000} />
              </p>

              <h4>Members</h4>
            </div>
          </div>

          <div className={styles.achievement}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-images"
              viewBox="0 0 16 16"
            >
              <path d="M4.502 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" />
              <path d="M14.002 13a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2V5A2 2 0 0 1 2 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-1.998 2M14 2H4a1 1 0 0 0-1 1h9.002a2 2 0 0 1 2 2v7A1 1 0 0 0 15 11V3a1 1 0 0 0-1-1M2.002 4a1 1 0 0 0-1 1v8l2.646-2.354a.5.5 0 0 1 .63-.062l2.66 1.773 3.71-3.71a.5.5 0 0 1 .577-.094l1.777 1.947V5a1 1 0 0 0-1-1z" />
            </svg>

            <div className={styles.details}>
              <p>
                <AnimatedCount end={500} />
              </p>

              <h4>Photos</h4>
            </div>
          </div>

          <div className={styles.achievement}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-calendar2-check"
              viewBox="0 0 16 16"
            >
              <path d="M10.854 8.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708 0" />
              <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z" />
              <path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5z" />
            </svg>

            <div className={styles.details}>
              <p>
                <AnimatedCount end={10} />
              </p>

              <h4>events</h4>
            </div>
          </div>

          <div className={styles.achievement}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-trophy"
              viewBox="0 0 16 16"
            >
              <path d="M2.5.5A.5.5 0 0 1 3 0h10a.5.5 0 0 1 .5.5q0 .807-.034 1.536a3 3 0 1 1-1.133 5.89c-.79 1.865-1.878 2.777-2.833 3.011v2.173l1.425.356c.194.048.377.135.537.255L13.3 15.1a.5.5 0 0 1-.3.9H3a.5.5 0 0 1-.3-.9l1.838-1.379c.16-.12.343-.207.537-.255L6.5 13.11v-2.173c-.955-.234-2.043-1.146-2.833-3.012a3 3 0 1 1-1.132-5.89A33 33 0 0 1 2.5.5m.099 2.54a2 2 0 0 0 .72 3.935c-.333-1.05-.588-2.346-.72-3.935m10.083 3.935a2 2 0 0 0 .72-3.935c-.133 1.59-.388 2.885-.72 3.935M3.504 1q.01.775.056 1.469c.13 2.028.457 3.546.87 4.667C5.294 9.48 6.484 10 7 10a.5.5 0 0 1 .5.5v2.61a1 1 0 0 1-.757.97l-1.426.356a.5.5 0 0 0-.179.085L4.5 15h7l-.638-.479a.5.5 0 0 0-.18-.085l-1.425-.356a1 1 0 0 1-.757-.97V10.5A.5.5 0 0 1 9 10c.516 0 1.706-.52 2.57-2.864.413-1.12.74-2.64.87-4.667q.045-.694.056-1.469z" />
            </svg>

            <div className={styles.details}>
              <p>
                <AnimatedCount end={5} />
              </p>

              <h4>Awards</h4>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Achievement;
